<app-material>
    <app-tabs header [tabs]="links"
              [material]="false">
    </app-tabs>
    <ng-container body>
        <router-outlet></router-outlet>
    </ng-container>
</app-material>
